import vehilePlate from "./vue-vehicle-plate";

const VueVehiclePlate = {
  install(Vue) {
    Vue.component("vue-vehicle-plate-2", vehilePlate);
  }
};

export default VueVehiclePlate;
